import placeholderIcon from '@SvgIcon/../event-image-placeholder.svg'

import imagesLoaded from 'imagesloaded'
import $ from 'jquery'
import each from 'lodash/each'
import Swiper from 'swiper'
import { A11y } from 'swiper/modules'
import Vue from 'vue'

import { thumbUrlFromFileObject } from '../../shared/fileArrayUrl'
import svgIconHtml from '../../shared/svgIconHtml'
import { setupVideos } from '../_video'
import EventInstanceModal from '../module/calendar/EventInstanceModal'
import { transformRawEvent } from '../module/calendar/transformRawEvent'

import '../../../scss/app/home.scss'

const app = document.getElementById('app')

//
// Home panel audio
//

const homePanelAudio = document.getElementById('home-panel-audio')
const homePanelAudioToggle = document.getElementById('home-panel-audio-toggle')

if (homePanelAudio && homePanelAudioToggle) {
  const $playIcon = $(homePanelAudioToggle).find('.play')
  const $pauseIcon = $(homePanelAudioToggle).find('.pause')
  homePanelAudio.addEventListener('pause', () => {
    $playIcon.removeClass('visible')
    $pauseIcon.addClass('visible')
  })
  homePanelAudio.addEventListener('play', () => {
    $playIcon.addClass('visible')
    $pauseIcon.removeClass('visible')
  })
  if (homePanelAudio.hasAttribute('data-autoplay')) {
    homePanelAudio.play()
  }
  homePanelAudioToggle.addEventListener('click', () => {
    if (homePanelAudio.paused) {
      homePanelAudio.play()
    } else {
      homePanelAudio.pause()
    }
  })
}

//
// Home panel slider
//

function getAvailableHeight() {
  const htmlEl = document.documentElement

  let availableHeight = Math.max(
    htmlEl.clientHeight - (app.getBoundingClientRect().top + window.pageYOffset),
    800, // also adjust in home.scss -> .home-panel-wrap
  )

  document.querySelectorAll('.announcement-wrap').forEach((el) => {
    availableHeight -= el.offsetHeight
  })

  return availableHeight
}

function initializePanel(panelWrap) {
  if (!panelWrap) {
    return
  }

  const panelDims = panelWrap.getBoundingClientRect()

  const videoInjector = panelWrap.querySelector('.js-video-injector')
  if (videoInjector) {
    // Don't recreate existing video elements. It takes too long to reload video on mobile.
    if (!videoInjector.querySelector('iframe') && !videoInjector.querySelector('video')) {
      setupVideos(panelWrap, false)
    }
  }

  const panelText = panelWrap.querySelector('.home-panel__content-above-video')
  const panelIcons = panelWrap.querySelector('.home-panel__icons')

  const doMargins = () => {
    if (panelText) {
      panelText.style.marginTop = 0
      panelText.style.marginBottom = 0
      const textHeight = panelText.getBoundingClientRect().height
      const iconsHeight = panelIcons ? panelIcons.getBoundingClientRect().height : 0
      const totalWhitespace = panelDims.height - iconsHeight - textHeight - 30
      panelText.style.marginTop = `${totalWhitespace / 2}px`
      panelText.style.marginBottom = `${totalWhitespace / 2}px`
    }
  }

  if (panelIcons) {
    imagesLoaded(panelIcons, doMargins)
  } else {
    doMargins()
  }
}

const ENTER_STAGGER_BASE_CLASS = 'enter-stagger-list'
const ENTER_STAGGER_MODIFIER_PREFIX = `${ENTER_STAGGER_BASE_CLASS}--`
const ENTER_STAGGER_ITEM_CAP = 20
const ENTER_STAGGER_DEFAULT_STEP_MS = 120
const ENTER_STAGGER_FAST_STEP_MS = 80
const ENTER_STAGGER_SLOW_STEP_MS = 160
const ENTER_STAGGER_DEFAULT_ANIMATION_CLASS = 'animate__fadeInDownSmall'
const ENTER_STAGGER_GENERATED_ATTR = 'data-enter-stagger-generated'
const ENTER_ANIMATE_DELAY_CSS_VAR = '--animate-delay'
const ENTER_STAGGER_INDEX_CSS_VAR = '--i'
const ENTER_STAGGER_BASE_DELAY_CSS_VAR = '--base-delay'
const ENTER_STAGGER_STEP_CSS_VAR = '--stagger-step'

function setupEnterStaggerListAnimations(panelWrap, classNamePrefix) {
  if (!panelWrap || classNamePrefix !== 'enter-') {
    return
  }

  const wrappers = panelWrap.querySelectorAll(`.${ENTER_STAGGER_BASE_CLASS}`)
  wrappers.forEach((wrapper) => {
    wrapper.querySelectorAll(`[${ENTER_STAGGER_GENERATED_ATTR}="true"]`).forEach((listItem) => {
      listItem.classList.forEach((className) => {
        if (className.startsWith(classNamePrefix)) {
          listItem.classList.remove(className)
        }
      })
      listItem.style.removeProperty(ENTER_STAGGER_INDEX_CSS_VAR)
      listItem.removeAttribute(ENTER_STAGGER_GENERATED_ATTR)
    })

    let animationClass = ENTER_STAGGER_DEFAULT_ANIMATION_CLASS
    let baseDelayMs = 0
    let staggerStepMs = ENTER_STAGGER_DEFAULT_STEP_MS

    wrapper.classList.forEach((className) => {
      if (!className.startsWith(ENTER_STAGGER_MODIFIER_PREFIX)) {
        return
      }

      const modifier = className.slice(ENTER_STAGGER_MODIFIER_PREFIX.length)
      const delayMatch = modifier.match(/^delay-(\d+)ms$/)
      if (delayMatch) {
        baseDelayMs = parseInt(delayMatch[1], 10)
        return
      }
      if (modifier === 'fast') {
        staggerStepMs = ENTER_STAGGER_FAST_STEP_MS
        return
      }
      if (modifier === 'slow') {
        staggerStepMs = ENTER_STAGGER_SLOW_STEP_MS
        return
      }
      if (/^[A-Za-z0-9_-]+$/.test(modifier)) {
        animationClass = modifier
      }
    })

    wrapper.style.setProperty(ENTER_STAGGER_BASE_DELAY_CSS_VAR, `${baseDelayMs}ms`)
    wrapper.style.setProperty(ENTER_STAGGER_STEP_CSS_VAR, `${staggerStepMs}ms`)

    const listItems = wrapper.querySelectorAll(':scope > ul > li, :scope > ol > li')
    listItems.forEach((listItem, index) => {
      if (index >= ENTER_STAGGER_ITEM_CAP) {
        return
      }

      if (Array.from(listItem.classList).some((className) => className.startsWith(`${classNamePrefix}animate__`))) {
        return
      }

      listItem.classList.add(`${classNamePrefix}${animationClass}`)
      listItem.style.setProperty(ENTER_STAGGER_INDEX_CSS_VAR, index.toString())
      listItem.setAttribute(ENTER_STAGGER_GENERATED_ATTR, 'true')
    })
  })
}

function playAnimations(panelWrap, classNamePrefix) {
  if (!panelWrap) {
    return new Promise((resolve) => {
      resolve()
    })
  }

  return new Promise((resolve) => {
    setupEnterStaggerListAnimations(panelWrap, classNamePrefix)

    const animationElements = panelWrap.querySelectorAll(`[class*="${classNamePrefix}animate__"]`)
    if (!animationElements.length) {
      resolve()
      return
    }

    let numAnimationsRunning = animationElements.length

    each(animationElements, (animateEl) => {
      let hasCompleted = false
      let fallbackTimeout = null

      const completeAnimation = () => {
        if (hasCompleted) {
          return
        }
        hasCompleted = true
        if (fallbackTimeout) {
          clearTimeout(fallbackTimeout)
          fallbackTimeout = null
        }
        numAnimationsRunning -= 1
        animateEl.removeEventListener('animationend', onAnimationEnd)

        if (numAnimationsRunning <= 0) {
          resolve()
        }
      }

      const onAnimationEnd = () => {
        completeAnimation()
      }

      /** @var Element animateEl */
      animateEl.addEventListener('animationend', onAnimationEnd)
      fallbackTimeout = setTimeout(() => {
        completeAnimation()
      }, 3000)

      animateEl.style.removeProperty(ENTER_ANIMATE_DELAY_CSS_VAR)
      const delayRegex = new RegExp(`${classNamePrefix}animate__delay-(\\d+)ms`, 'ig')
      let delayMatch = delayRegex.exec(animateEl.className)
      let delayMs = null
      while (delayMatch) {
        delayMs = delayMatch[1]
        delayMatch = delayRegex.exec(animateEl.className)
      }
      if (delayMs !== null) {
        animateEl.style.setProperty(ENTER_ANIMATE_DELAY_CSS_VAR, `${delayMs}ms`)
      }

      // Restore the original class name to eliminate any existing animations.
      if ('app__origClassName' in animateEl) {
        animateEl.className = animateEl.app__origClassName
      }
      // Store the original class name so we can reset the animations.
      animateEl.app__origClassName = animateEl.className

      // Play the animations
      const re = RegExp(`(${classNamePrefix}([^\\s]+))`, 'ig')
      const newClassName = animateEl.className.replace(
        re,
        (fullMatch, fullClassName, actualClassName) => actualClassName,
      )
      animateEl.className = `${newClassName} animate__animated`
    })
  })
}

function resetAnimations(panelWrap) {
  if (!panelWrap) {
    return
  }

  panelWrap.querySelectorAll('*').forEach((animateEl) => {
    if ('app__origClassName' in animateEl) {
      animateEl.className = animateEl.app__origClassName
    }
  })
}

function onPanelEnter(panelWrap) {
  if (!panelWrap) {
    return
  }

  if (panelWrap.hasAttribute('data-move-icon-bar')) {
    const iconBar = document.querySelector('.action-icons')
    if (iconBar && !panelWrap.querySelector('.action-icons')) {
      panelWrap.querySelector('.home-panel__content .cms-ve').appendChild(iconBar)
      iconBar.className += ' home-panel__icons'
    }
  }

  playAnimations(panelWrap, 'enter-').then()

  panelWrap.querySelectorAll('video').forEach((video) => {
    if (video.hasAttribute('data-src')) {
      video.setAttribute('src', video.getAttribute('data-src'))
      video.removeAttribute('data-src')
    }
  })

  initializePanel(panelWrap)
}

function onPanelExit(panelWrap) {
  if (!panelWrap) {
    return
  }

  resetAnimations(panelWrap)
}

function initHome() {
  const swiperEl = document.getElementById('home-panel-swiper')
  const panelSelector = '.home-panel-wrap'
  const initializingClassName = 'is-initializing'

  if (swiperEl) {
    const isAutoHeight = swiperEl.hasAttribute('data-auto-height')

    // Try to prevent drastic page height shifts by setting visibility hidden:
    swiperEl.classList.add(initializingClassName)

    let autoplayTimeout = null
    let autoplayTimeoutPausedByVisibilityChange = false

    // const makeOnlyVisiblePanelsFocusable = () => {
    //   const focusableElemsSelector = 'a, button, input, textarea, [tabindex=0], select'
    //   $panelsContainer.find(panelSelector).each((i, panel) => {
    //     $(panel).find(focusableElemsSelector).attr('tabindex', '-1')
    //   })
    //   $(activePanel).find(focusableElemsSelector).removeAttr('tabindex')
    // }

    const numSlides = swiperEl.querySelectorAll(panelSelector).length
    const availableHeight = isAutoHeight ? null : getAvailableHeight()
    if (availableHeight !== null) {
      swiperEl.style.setProperty('--panel-height', `${availableHeight}px`)
    } else {
      swiperEl.style.removeProperty('--panel-height')
    }

    const swiperOptions = {
      modules: [A11y],
      a11y: true,
      autoHeight: isAutoHeight,
      setWrapperSize: true,
      threshold: 40,
      loop: numSlides > 1,
      on: {
        init(swpr) {
          /**
           * @return HTMLButtonElement
           */
          const createButton = (className, ariaLabel, html) => {
            const arrow = document.createElement('button')
            arrow.className = `slider-btn ${className}`
            arrow.type = 'button'
            arrow.setAttribute('aria-label', ariaLabel)
            arrow.innerHTML = html
            return arrow
          }

          const goNext = () => {
            return new Promise((resolve) => {
              swpr.slideNext()
              resolve()
            })
          }

          const goPrev = () => {
            return new Promise((resolve) => {
              swpr.slidePrev()
              resolve()
            })
          }

          const panels = swiperEl.querySelectorAll(panelSelector)
          if (panels.length > 1) {
            // Set up prev/next arrows:
            const prevArrow = createButton(
              'slider-btn-prev',
              'Previous slide',
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>',
            )
            prevArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goPrev().then()
            }

            const nextArrow = createButton(
              'slider-btn-next',
              'Next slide',
              '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>',
            )
            nextArrow.onclick = () => {
              clearTimeout(autoplayTimeout)
              goNext().then()
            }

            const buttonsFragment = document.createDocumentFragment()
            buttonsFragment.appendChild(prevArrow)
            buttonsFragment.appendChild(nextArrow)
            swiperEl.appendChild(buttonsFragment)
          }

          swiperEl.classList.remove(initializingClassName)
          if (panels.length) {
            onPanelEnter(Array.from(panels)[0])
          }

          // Timeout so that exit animations have a chance to play.
          const nextTimeout = () => {
            const showForSeconds = parseInt(swpr.slides[swpr.realIndex].getAttribute('data-show-for'), 10)
            autoplayTimeout = setTimeout(
              async () => {
                await goNext()
                nextTimeout()
              },
              !Number.isNaN(showForSeconds) && showForSeconds > 0 ? showForSeconds * 1000 : 5500,
            )
          }
          nextTimeout()

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden' || document.hidden) {
              if (autoplayTimeout) {
                autoplayTimeoutPausedByVisibilityChange = true
              }
              clearTimeout(autoplayTimeout)
            } else if (autoplayTimeoutPausedByVisibilityChange) {
              autoplayTimeoutPausedByVisibilityChange = false
              nextTimeout()
            }
          })
        },
      },
    }

    if (availableHeight !== null) {
      swiperOptions.height = availableHeight
    }

    const swiper = new Swiper(swiperEl, swiperOptions)

    swiper.on('touchStart', () => {
      clearTimeout(autoplayTimeout)
    })

    swiper.on('slideChange', (swpr) => {
      onPanelExit(swpr.slides[swpr.previousIndex])
      onPanelEnter(swpr.slides[swpr.realIndex])
    })

    // Observe new panels:

    const panelObserver = new MutationObserver((mutations) => {
      each(mutations, (mutation) => {
        each(mutation.addedNodes, (node) => {
          if (node.nodeType !== 1) {
            return
          }

          node.querySelectorAll(panelSelector).forEach((panelWrap) => {
            initializePanel(panelWrap)
          })
        })
      })
    })

    panelObserver.observe(swiperEl, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false,
    })
  }
}

if (module.hot) {
  $(window).on('load', initHome)
} else {
  initHome()
}

//
// Events
//

const eventsAppContainer = document.querySelector('.js-events')
if (eventsAppContainer) {
  new Vue({
    components: {
      EventInstanceModal,
    },
    name: 'EventsWidget',
    el: eventsAppContainer,
    props: {
      events: Array,
    },
    propsData: {
      events: JSON.parse(eventsAppContainer.dataset.events).map(transformRawEvent),
    },
    template: `
      <div class="event-widget">
        <p v-if="events.length === 0" class="text-center">
          Nothing scheduled. Check back soon!
        </p>
        <div v-else class="event-widget__events">
          <button
              v-for="event in events"
              class="event-widget__event"
              @click="viewEvent(event)"
          >
            <div class="event-widget__event-photo is-custom-photo" v-if="eventPhotoThumbUrl(event)">
              <img :src="eventPhotoThumbUrl(event)" alt="">
              <template v-else>${svgIconHtml(placeholderIcon)}</template>
            </div>
            <div class="event-widget__event-photo is-default-photo" v-else>
              ${svgIconHtml(placeholderIcon)}
            </div>
            <div class="event-widget__event-date">
              <div class="start date">
                <div class="month">{{ event.dateStartMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateStartMoment.format('D') }}</div>
              </div>
              <div class="end date" v-if="event.dateStart !== event.dateEnd">
                <div class="month">{{ event.dateEndMoment.format('MMM') }}</div>
                <div class="day">{{ event.dateEndMoment.format('D') }}</div>
              </div>
            </div>
            <div class="event-widget__event-info">
              <div class="event-widget__event-title">{{ event.title }}</div>
              <div v-if="event.cancelled" class="event-widget__event-cancelled">Cancelled!</div>
            </div>
          </button>
        </div>
        <EventInstanceModal ref="modal" />
      </div>
    `,
    methods: {
      viewEvent(event) {
        this.$refs.modal.show(event.title, event.dataUrl)
      },

      eventPhotoThumbUrl(event) {
        return thumbUrlFromFileObject(event.photo)
      },
    },
  })
}
